/* QJ Mobile Nav — opens/closes the Target-style mobile menu panel and runs
   the accordion rows. The hamburger/X markup lives in snippets/header-drawer.liquid
   (.drp--menu_inner--container .icons-wrapper); this script owns all behavior. */
(function () {
  if (window.__qjMnavBound) return;
  window.__qjMnavBound = true;

  function nav() {
    return document.querySelector('.qj-mnav');
  }

  function container() {
    return document.querySelector('.drp--menu_inner--container');
  }

  function isOpen() {
    return document.body.classList.contains('qj-mnav-open');
  }

  /* Pin the panel's top edge to the bottom of the blue header bar. */
  function setTop() {
    var n = nav();
    var c = container();
    if (!n || !c) return;
    var bar = c.closest('.mobile_menu') || c;
    var bottom = Math.max(0, bar.getBoundingClientRect().bottom);
    n.style.setProperty('--qj-mnav-top', bottom + 'px');
  }

  function open() {
    if (!nav()) return;
    setTop();
    document.body.classList.add('qj-mnav-open');
    var c = container();
    if (c) c.classList.add('active');
  }

  function close() {
    document.body.classList.remove('qj-mnav-open');
    var c = container();
    if (c) c.classList.remove('active');
  }

  document.addEventListener('click', function (e) {
    var iw = e.target.closest('.icons-wrapper');
    if (iw && container() && container().contains(iw)) {
      e.preventDefault();
      isOpen() ? close() : open();
      return;
    }

    /* Tap on the dimmed area beside the drawer closes the menu. */
    if (isOpen() && e.target.classList && e.target.classList.contains('qj-mnav')) {
      close();
      return;
    }

    var toggle = e.target.closest('[data-qj-toggle]');
    var n = nav();
    if (toggle && n && n.contains(toggle)) {
      var li = toggle.parentElement;
      var willOpen = !li.classList.contains('open');
      var singleOpen = n.getAttribute('data-single-open') !== 'false';
      if (singleOpen && willOpen) {
        var siblings = li.parentElement.children;
        for (var i = 0; i < siblings.length; i++) {
          var s = siblings[i];
          if (s === li) continue;
          s.classList.remove('open');
          var nested = s.querySelectorAll('.open');
          for (var j = 0; j < nested.length; j++) nested[j].classList.remove('open');
          var btns = s.querySelectorAll('[data-qj-toggle][aria-expanded="true"]');
          for (var k = 0; k < btns.length; k++) btns[k].setAttribute('aria-expanded', 'false');
        }
      }
      li.classList.toggle('open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 1025) {
      close();
    } else if (isOpen()) {
      setTop();
    }
  });

  window.addEventListener('scroll', function () {
    if (isOpen()) setTop();
  }, { passive: true });

  /* Theme editor: selecting the section opens the panel so the team can see
     their changes; deselecting closes it. */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.qj-mnav')) open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.qj-mnav')) close();
  });
})();
